var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{attrs:{"data-top-right-id":"search"}},[_c('button',{staticClass:"btn-search",on:{"click":_vm.toggleSearchDialog}},[_c('i',{staticClass:"fas fa-search"})])])}
var staticRenderFns = []

export { render, staticRenderFns }